import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Award02 = function Award02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M7 15.0903V22l4.7029-1.8812c.1097-.0439.1646-.0658.2213-.0745a.5.5 0 0 1 .1516 0c.0567.0087.1116.0306.2213.0745L17 22v-6.9097M19.5 9.5c0 4.1421-3.3579 7.5-7.5 7.5s-7.5-3.3579-7.5-7.5S7.8579 2 12 2s7.5 3.3579 7.5 7.5"
    })
  }));
};
export default Award02;